// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { BaseExtLink } from './BaseExtLink';
import { BrandingToolLinkGenerator } from './Branding/BrandingToolLinkGenerator';
import { YouTubeHTMLConfig } from './YouTubeHTMLConfig';
import { ExtLinkUtils } from '../../UtilsClasses/ExtLinkUtils';
export class YoutubeExtLink extends BaseExtLink {
    constructor(availUntil = -1, liveStream = false, url = '', clientUseInternalBrowser = false) {
        super();
        this.availUntil = -1;
        this.availUntilDate = new Date();
        this.liveStream = false;
        this.config = new YouTubeHTMLConfig();
        this.availUntil = availUntil;
        this.availUntilDate = new Date(availUntil);
        this.liveStream = liveStream;
        this.urlStr = url;
        this.clientUseInternalBrowser = clientUseInternalBrowser;
    }
    update(brandingTool, extLinkMessage) {
        var _a, _b;
        super.update(brandingTool, extLinkMessage);
        this.availUntil = (_a = brandingTool === null || brandingTool === void 0 ? void 0 : brandingTool.availableUntil) !== null && _a !== void 0 ? _a : this.availUntil;
        this.availUntilDate = new Date(this.availUntil);
        this.liveStream = (_b = brandingTool === null || brandingTool === void 0 ? void 0 : brandingTool.liveStream) !== null && _b !== void 0 ? _b : this.liveStream;
    }
    generateUrl() {
        const url = BrandingToolLinkGenerator.generateLinkNoneURL(this);
        if (url) {
            this.url = url;
            if (this.updateValue) {
                this.updateValue(url);
            }
        }
    }
    get videoID() {
        return ExtLinkUtils.getVideoIDFromYouTubeLink(this.urlStr);
    }
    get embedUrl() {
        return ExtLinkUtils.getEmbedYouTubeLinkByVideoID(this.videoID);
    }
}
